export const EMAIL_ADDRESS = {
  CN: 'pagamo.cn@bonio.com.tw',
  MY: 'info@pagamo.com.my',
  HK: 'cs@e2sports.hk',
  GLOBAL: 'info@pagamo.org',
}

export const TEL_NUMBER = {
  CN: '15102128503',
  MY: '+603-95441033',
  HK: '+852-3697-7030',
  GLOBAL: '+886-2-2358-2553',
}
